<router-outlet></router-outlet>
@if (loading()) {
<div class="loading">
    <div class="gif"></div>
</div>
}
<app-msg-popup></app-msg-popup>
